import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeReadySIO } from '../../actions'
import { getSelectedProductLifeReadySIO } from '../selectors'
import VALUES from 'core/data-model/constants/values'

export const LifeReadySIOProductSelection = ({ getSelectedProductLifeReadySIO, selectProductLifeReadySIO }) => {
  const productLifeReadySIO = [
    {
      text: '6 ปี',
      value: VALUES.LIFEREADY_SIO_CODE.LIFEREADY6_SIO,
    },
    {
      text: '12 ปี',
      value: VALUES.LIFEREADY_SIO_CODE.LIFEREADY12_SIO,
    },
    {
      text: '18 ปี',
      value: VALUES.LIFEREADY_SIO_CODE.LIFEREADY18_UNDER_SIO,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.LIFEREADY_SIO_CODE.LIFEREADY99_UNDER_SIO,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeReadySIO}
        value={getSelectedProductLifeReadySIO}
        options={productLifeReadySIO}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductLifeReadySIO: getSelectedProductLifeReadySIO(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeReadySIO: bindActionCreators(selectProductLifeReadySIO, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LifeReadySIOProductSelection)
